import { userAxiosInstance, customerAxiosInstance, lotAxiosInstance, developmentAxiosInstance } from './http';
import mixin from '../utils/mixin';
import jwt_decode from "jwt-decode";

const { methods } = mixin;

// ----------- LOTS API ----------- //
export const getLotsByDevelopment = ({development_id})=>
    lotAxiosInstance(
        `/bydevelopment/${development_id}`,
        {
            method: 'GET',
            responseType: 'json'

        }).then((res) => {
            if(res.data.data && res.data.data.length){
                return res.data.data;
            }else{
                return null;
            }
        })
          .catch((err) => err);

export const getTowersByDevelopment = ({development_id})=>
    lotAxiosInstance(
        `/towers/bydevelopment/${development_id}`,
        {
            method: 'GET',
            responseType: 'json'

        }).then((res) => {
            if(res.data.data && res.data.data.length){
                return res.data.data;
            }else{
                return null;
            }
        })
          .catch((err) => err);

export const getStoriesByDevelopment = ({development_id})=>
    lotAxiosInstance(
        `/stories/bydevelopment/${development_id}`,
        {
            method: 'GET',
            responseType: 'json'

        }).then((res) => {
            if(res.data.data && res.data.data.length){
                return res.data.data;
            }else{
                return null;
            }
        })
          .catch((err) => err);

export const getSeparatorsByDevelopment = ({development_id})=>
    lotAxiosInstance(
        `/separators/bydevelopment/${development_id}`,
        {
            method: 'GET',
            responseType: 'json'

        }).then((res) => {
            if(res.data.data && res.data.data.length){
                return res.data.data;
            }else{
                return null;
            }
        })
          .catch((err) => err);

export const addLot = (data)=>
    lotAxiosInstance(
        ``,
        {
            method: 'POST',
            data: data,
            responseType: 'json'

        }).then((res) => {
            if(res.data.data){
                return res.data.data;
            }else{
                return null;
            }
        })
        .catch((err) => err);

export const updateLot = ({lot_id, data})=>
    lotAxiosInstance(
        `/${lot_id}`,
        {
            method: 'PUT',
            data: data,
            responseType: 'json'

        }).then((res) => {
            if(res.data.data){
                return res.data.data;
            }else{
                return null;
            }
        })
        .catch((err) => err);

export const deleteLot = (lot_id)=>
    lotAxiosInstance(
        `/${lot_id}`,
        {
            method: 'DELETE',
            data: {},
            responseType: 'json'

        }).then((res) => {
            if(res.data.data){
                return res.data.data;
            }else{
                return null;
            }
        })
        .catch((err) => err);

export const reserveLot = ({lot_id, data})=>
    lotAxiosInstance(
        `/${lot_id}/reserve`,
        {
            method: 'POST',
            data: data,
            responseType: 'json'

        }).then((res) => {
            if(res.data.data){
                return res.data.data;
            }else{
                return null;
            }
        })
        .catch((err) => err);

export const paymentLot = ({lot_id, data})=>
    lotAxiosInstance(
        `/${lot_id}/payment`,
        {
            method: 'POST',
            data: data,
            responseType: 'json'

        }).then((res) => {
            if(res.data.data){
                return res.data.data;
            }else{
                return null;
            }
        })
        .catch((err) => err);

export const getReservationDetails = (lot_id)=>
    lotAxiosInstance(
        `/${lot_id}/transaction`,
        {
            method: 'GET',
            responseType: 'json'

        }).then((res) => {
            if(res.data.data){
                return res.data.data;
            }else{
                return null;
            }
        })
        .catch((err) => err);

export const cancelReservation = (lot_id)=>
    lotAxiosInstance(
        `/${lot_id}/reserve`,
        {
            method: 'DELETE',
            data: {},
            responseType: 'json'

        }).then((res) => {
            if(res.data.data){
                return res.data.data;
            }else{
                return null;
            }
        })
        .catch((err) => err);

export const approveReservation = (lot_id) =>
    lotAxiosInstance(
        `/${lot_id}/reserve/confirm`,
        {
            method: 'PUT',
            data: {},
            responseType: 'json'

        }).then((res) => {
            if(res.data.data){
                return res.data.data;
            }else{
                return null;
            }
        })
        .catch((err) => err);
        
export const getLogByLot = (lot_id)=>
    lotAxiosInstance(
        `/${lot_id}/log`,
        {
            method: 'GET',
            responseType: 'json'

        }).then((res) => {
            if(res.data.data && res.data.data.length){
                return res.data.data;
            }else{
                return null;
            }
        })
            .catch((err) => err);

export const addActivityLog = ({lot_id, data})=>
    lotAxiosInstance(
        `/${lot_id}/log`,
        {
            method: 'POST',
            data: data,
            responseType: 'json'

        }).then((res) => {
            if(res.data.data){
                return res.data.data;
            }else{
                return null;
            }
        })
        .catch((err) => err);

export const getSettingsStatus = ()=>
    lotAxiosInstance(
        `/settings/status`,
        {
            method: 'GET',
            responseType: 'json'

        }).then((res) => {
            if(res.data.data && res.data.data.length){
                return res.data.data;
            }else{
                return null;
            }
        })
            .catch((err) => err);
    
// ----------- END LOTS API ----------- //

// ----------- USER API ----------- //
export const login = ({username, password})=>
    userAxiosInstance(
        `/auth`,
        {
            method: 'POST',
            data: { username, password },
            responseType: 'json'

        }).then((res) => {
            if(res.data.data && res.data.data.jwt){
                localStorage.setItem("jwt", res.data.data.jwt);

                const decoded = jwt_decode(res.data.data.jwt);
                const user = decoded.identity;
                
                localStorage.setItem("user", JSON.stringify(user));
                localStorage.setItem("developments", JSON.stringify(res.data.data.developments));

                methods.G_changeLanguage('es');

                return res.data.data;
            }else{
                return null;
            }
        })
          .catch((err) => err);

export const recoverPassword = (username)=>
    userAxiosInstance(
        `/forgot-password`,
        {
            method: 'POST',
            data: { email: username },
            responseType: 'json'

        }).then((res) => {
            if(res.data.data.success){
                return res.data.data;
            }else{
                return null;
            }
        })
          .catch((err) => err);

export const resetPassword = ({password, token})=>
    userAxiosInstance(
        `/recover-password/${token}`,
        {
            method: 'POST',
            data: { password: password },
            responseType: 'json'

        }).then((res) => {
            if(res.data.data.success){
                return res.data.data;
            }else{
                return null;
            }
        })
          .catch((err) => err);

export const getUsersByDevelopment = ({development_id})=>
    userAxiosInstance(
        `/bydevelopment/${development_id}`,
        {
            method: 'GET',
            responseType: 'json'

        }).then((res) => {
            if(res.data.data && res.data.data.length){
                return res.data.data;
            }else{
                return null;
            }
        })
        .catch((err) => err);

export const getCurrentUser = ()=>
    userAxiosInstance(
        `/me`,
        {
            method: 'GET',
            responseType: 'json'

        }).then((res) => {
            if(res.data.data){
                return res.data.data;
            }else{
                return null;
            }
        })
        .catch((err) => err);

export const changePassword = (current_password, new_password)=>
    userAxiosInstance(
        `/change-password`,
        {
            method: 'POST',
            data: { password: current_password, new_password: new_password },
            responseType: 'json'

        }).then((res) => {
            if(res.data.data){
                return res.data.data;
            }else{
                return null;
            }
        })
        .catch((err) => err);

export const addUser = (data)=>
    userAxiosInstance(
        ``,
        {
            method: 'POST',
            data: data,
            responseType: 'json'

        }).then((res) => {
            if(res.data.data){
                return res.data.data;
            }else{
                return null;
            }
        })
        .catch((err) => err);

export const updateUser = ({user_id, data})=>
    userAxiosInstance(
        `/${user_id}`,
        {
            method: 'PUT',
            data: data,
            responseType: 'json'

        }).then((res) => {
            if(res.data.data){
                return res.data.data;
            }else{
                return null;
            }
        })
        .catch((err) => err);

export const deleteUser = (user_id)=>
    userAxiosInstance(
        `/${user_id}`,
        {
            method: 'DELETE',
            data: {},
            responseType: 'json'

        }).then((res) => {
            if(res.data.data){
                return res.data.data;
            }else{
                return null;
            }
        })
        .catch((err) => err);

export const getAgentsByUser = ({user_id})=>
    userAxiosInstance(
        `/agent/byuser/${user_id}`,
        {
            method: 'GET',
            responseType: 'json'

        }).then((res) => {
            if(res.data.data && res.data.data.length){
                return res.data.data;
            }else{
                return null;
            }
        })
        .catch((err) => err);

export const getAgentsByUserCode = (user_code)=>
    userAxiosInstance(
        `/agent/byusercode/${user_code}`,
        {
            method: 'GET',
            responseType: 'json'

        }).then((res) => {
            if(res.data.data && res.data.data.length){
                return res.data.data;
            }else{
                return null;
            }
        })
        .catch((err) => err);

export const addAgent = (data)=>
    userAxiosInstance(
        `/agent`,
        {
            method: 'POST',
            data: data,
            responseType: 'json'

        }).then((res) => {
            if(res.data.data){
                return res.data.data;
            }else{
                return null;
            }
        })
        .catch((err) => err);

export const updateAgent = ({agent_id, data})=>
    userAxiosInstance(
        `/agent/${agent_id}`,
        {
            method: 'PUT',
            data: data,
            responseType: 'json'

        }).then((res) => {
            if(res.data.data){
                return res.data.data;
            }else{
                return null;
            }
        })
        .catch((err) => err);

export const deleteAgent = (agent_id)=>
    userAxiosInstance(
        `/agent/${agent_id}`,
        {
            method: 'DELETE',
            data: {},
            responseType: 'json'

        }).then((res) => {
            if(res.data.data){
                return res.data.data;
            }else{
                return null;
            }
        })
        .catch((err) => err);

// ----------- END USER API ----------- //

// ----------- DEVELOPMENT API ----------- //
export const getTransactionsByDevelopment = ({development_id})=>
    developmentAxiosInstance(
        `/${development_id}/transaction`,
        {
            method: 'GET',
            responseType: 'json'

        }).then((res) => {
            if(res.data.data && res.data.data.length){
                return res.data.data;
            }else{
                return null;
            }
        })
          .catch((err) => err);

export const getActivityByDevelopment = ({development_id, since, until, user, agent, type})=>
    developmentAxiosInstance(
        `/${development_id}/activity?since=${since}&until=${until}${user ? ('&user=' + user) : ''}${agent ? ('&agent=' + agent) : ''}${type ? ('&type=' + type) : ''}`,
        {
            method: 'GET',
            responseType: 'json'

        }).then((res) => {
            if(res.data.data && res.data.data.length){
                return res.data.data;
            }else{
                return null;
            }
        })
          .catch((err) => err);

export const getHeatMapByDevelopment = ({development_id, since, until, user, agent, type})=>
    developmentAxiosInstance(
        `/${development_id}/heatmap?since=${since}&until=${until}${user ? ('&user=' + user) : ''}${agent ? ('&agent=' + agent) : ''}${type ? ('&type=' + type) : ''}`,
        {
            method: 'GET',
            responseType: 'json'

        }).then((res) => {
            if(res.data.data && res.data.data.lots && res.data.data.lots.length){
                return res.data.data;
            }else{
                return null;
            }
        })
          .catch((err) => err);

export const getDevelopmentById = (development_id)=>
    developmentAxiosInstance(
        `/${development_id}`,
        {
            method: 'GET',
            responseType: 'json'

        }).then((res) => {
            if(res.data.data){
                return res.data.data;
            }else{
                return null;
            }
        })
          .catch((err) => err);

export const getDevelopmentByCode = (code)=>
    developmentAxiosInstance(
        `/bycode/${code}`,
        {
            method: 'GET',
            responseType: 'json'

        }).then((res) => {
            if(res.data.data){
                return res.data.data;
            }else{
                return null;
            }
        })
          .catch((err) => err);

// ----------- END DEVELOPMENT API ----------- //
